import React, {useState, useContext, useEffect, useCallback, useLayoutEffect} from "react";
import {DialogContext, RealmContext, TokenContext} from "../../Store";

import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import {Form, Formik} from "formik";

import http from "../../../shared/http-common";

import ProjectService from "../../../services/ProjectService";

import LoadingIndicator from "../../../shared/LoadingIndicator";

import {useStylesDialog} from "../../../shared/useStyleDialog";

import ObjecttypeService from "../../../services/ObjecttypeService";
import BimProjectAppBar from "./BimProjectAppBar";
import BimProjectTabs from "./BimProjectTabs";

// Fenster zum Anlegen eines Projekts

const initialValues = {
    name: '',
    description: '',
    componenttypes: [],
    guid: '',
    id: null,
    profileId: null,
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

function BimProjectCreate({bimProjectData, reloadProjects, setBimProjectSelected}) {
    const classesDialog = useStylesDialog();
    const dialog = useContext(DialogContext);
    const BIMDialogOpen = dialog.bimOpen;
    const setBIMDialogOpen = dialog.setBimOpen;
    const [token] = useContext(TokenContext);
    const [realm] = useContext(RealmContext);
    const [profileId, setProfileId] = useState(null);
    const [guid, setGuid] = useState("");
    const [formValues, setFormValues] = useState(null);
    const [users, setUsers] = useState([]);
    const [checkedRights, setCheckedRights] = useState([]);
    const [optionsRealestateobject, setOptionsRealestateobject] = useState([]);

    const getRealestateobjectTypes = useCallback(async (token, theRealm) => {
        try {
            const res = await ObjecttypeService.getRealestateobjecttypes(token, theRealm);
            const myOptions = [{value: '', text: ' - Bitte wählen -'}];
            if (res.data instanceof Array) {
                res.data.forEach((val) => myOptions.push({value: val.guid, text: val.label}));
            }
            setOptionsRealestateobject(myOptions);
        } catch (e) {
            console.error('Fehler beim Laden der Objekttypen:', e);
        }
    }, []);

    useEffect(() => {
        getRealestateobjectTypes(token, realm);
    }, [getRealestateobjectTypes, token, realm]);

    const handleChange = (event) => {
        const rights = checkedRights.rights;
        rights?.forEach((r) => {
            if (r.username === event.target.name) {
                if (event.target.value === 'read') {
                    r.read = event.target.checked;
                } else if (event.target.value === 'write') {
                    r.write = event.target.checked;
                }
            }
        });
        setCheckedRights({ rights });
    };

    useLayoutEffect(() => {
        if (bimProjectData?.id) {
            setFormValues({
                name: bimProjectData.name,
                description: bimProjectData.description,
                guid: bimProjectData.guid,
                id: bimProjectData.id,
                profileId: bimProjectData.bimProfileId,
                realestateobjectLevelGuid: bimProjectData.realestateobjectLevelGuid,
            });
        } else {
            setFormValues({
                name: "",
                description: "",
                guid: "",
                id: null,
                profileId: null,
                realestateobjectLevelGuid: null,
            });
        }
    }, [bimProjectData]);

    useEffect(() => {
        setCheckedRights([]);

        if (bimProjectData?.id) {
            setGuid(bimProjectData.guid);
            setProfileId(bimProjectData.bimProfileId);

            const loadUsers = async () => {
                try {
                    const result = await ProjectService.getKeycloakUser(token, realm);
                    setUsers(result.data);
                    const rights = (result.data || []).map(u => ({
                        username: u.username,
                        read: false,
                        write: false,
                        userId: u.id,
                    }));
                    setCheckedRights({ rights });

                    const rightsResult = await ProjectService.getProjectUserRights(
                        token, realm, bimProjectData.id, bimProjectData.guid
                    );
                    if (rightsResult?.data instanceof Array) {
                        rightsResult.data.forEach((r) => {
                            const user = rights.find(u => u.username === r.username);
                            if (user) {
                                user.read = r.read;
                                user.write = r.write;
                            }
                        });
                        setCheckedRights({ rights });
                    }
                } catch (e) {
                    console.error('Fehler beim Laden der Benutzerrechte:', e);
                }
            };
            loadUsers();
        } else {
            setGuid("");
            setProfileId(null);
        }
    }, [bimProjectData]); // eslint-disable-line react-hooks/exhaustive-deps

    const saveProject = async (formData) => {
        try {
            const res = await http.post(`/project/save`, formData, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token,
                }
            });
            await reloadProjects(res.data);
        } catch (e) {
            console.error('Fehler beim Speichern des Projekts:', e);
        }
    };

    return (
        <Dialog
            className={classesDialog.dialog}
            open={BIMDialogOpen}
            onClose={() => setBIMDialogOpen(false)}
            TransitionComponent={Transition}
            fullScreen
        >
            <BimProjectForm
                formValues={formValues}
                initialValues={initialValues}
                bimProjectData={bimProjectData}
                realm={realm}
                setProfileId={setProfileId}
                profileId={profileId}
                optionsRealestateobject={optionsRealestateobject}
                users={users}
                handleChange={handleChange}
                guid={guid}
                saveProject={saveProject}
                checkedRights={checkedRights}
            />
        </Dialog>
    );
}

export default BimProjectCreate;

function BimProjectForm({formValues, initialValues, bimProjectData, realm, setProfileId, profileId, optionsRealestateobject, users, handleChange, guid, saveProject, checkedRights}) {
    const dialogCtx = useContext(DialogContext);
    const setBIMDialogOpen = dialogCtx.setBimOpen;
    const [selectedRealestateobject, setSelectedRealestateobject] = useState('');
    const [hideSaveButton, setHideSaveButton] = useState(false);

    return (
        <Formik
            initialValues={formValues || initialValues}
            onSubmit={async (values, { setSubmitting }) => {
                const projectUserRights = [];
                users.forEach((u) => {
                    checkedRights.rights?.forEach((r) => {
                        if (u.username === r.username) {
                            projectUserRights.push({
                                username: u.username,
                                read: r.read,
                                write: r.write,
                                userId: r.userId,
                            });
                        }
                    });
                });

                const project = {
                    name: values.name,
                    description: values.description,
                    profileId: profileId,
                    guid: guid,
                    realestateobjectLevelGuid: selectedRealestateobject,
                };
                const formData = new FormData();
                formData.append("realm", realm);
                formData.append("data", JSON.stringify(project));
                formData.append("projectUserRights", JSON.stringify(projectUserRights));

                await saveProject(formData);
                setSubmitting(false);
            }}
        >
            <Form>
                <BimProjectAppBar setBIMDialogOpen={setBIMDialogOpen}
                                  objectId={bimProjectData?.id}
                                  hideSaveButton={hideSaveButton}
                />
                <LoadingIndicator/>
                <BimProjectTabs
                    users={users}
                    bimProjectData={bimProjectData}
                    checkedRights={checkedRights}
                    handleChange={handleChange}
                    realm={realm}
                    setProfileId={setProfileId}
                    profileId={profileId}
                    optionsRealestateobject={optionsRealestateobject}
                    setSelectedRealestateobject={setSelectedRealestateobject}
                    selectedRealestateobject={selectedRealestateobject}
                    setHideSaveButton={setHideSaveButton}
                />
            </Form>
        </Formik>
    );
}
